import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Table } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getReportDetails, doReportCreate, doReportUpdate 
} from "../../../../redux/report/reportState";
import { useForm } from 'antd/lib/form/Form';
import DownloadButton from "components/button/download";

const ReportViewItems = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			const initialValues = {
				rpt_id: recordData.rpt_id,
				rpt_title: recordData.rpt_title,
			    rpt_description: recordData.rpt_description,
			    rpt_service: recordData.rpt_service,
			    rpt_account_id: recordData.rpt_account_id,
			    rpt_status_id: recordData.rpt_status_id,
			    rpt_module_id: recordData.rpt_module_id,
			};	
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
    const columns = [
		{
	        title: `Name`,
	        dataIndex: 'monthName',
	        key: 'monthName',
	        width: '80%',
	        render:(monthName) => <span>{monthName}</span>
	    },	    
	    {
	        title: 'Action',
	        dataIndex: 'month',
	        key: 'month',
	        width: '20%',
	        render:(month) => <DownloadButton downloadPath={recordData?.rpt_download_route} title="Download" filters={{month: month}}/>
	    },
    ];
  
  	return (<>
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
	        >   
        		<div className="grid grid-cols-4 gap-4">
	            	<FormItem className="font-medium mb-2"
		            	name="rpt_title"
		                label="Title"
		            >
		                <label className="ps-3 dark:text-white">{recordData?.rpt_title}</label>
	            	</FormItem>		            		            	
	            	<FormItem className="font-medium  mb-2 col-span-2"
		            	name="rpt_description"
		                label="Description"
		            >
		                <label className="ps-3 dark:text-white">{recordData?.rpt_description}</label>		                
	            	</FormItem>	            	
	 			</div>	 			 			
	 		</Form>
	 		
	 	</Card>
	 	<Card extra={"w-full h-full p-4"}>
	 		<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordData?.items} 
		        	columns={columns} 
		            rowKey={(record) => record.rpt_id}
					pagination={false}
	        	/>
	      	</div>
      	</Card>
  	</>);
};

const mapStateToProps = (state) => ({
  	recordData: state.report.reportDetails?.data,
  	requesting: state.report.reportDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getReportDetails(id)),
  	doCreate: (data) => dispatch(doReportCreate(data)),
  	doUpdate: (data) => dispatch(doReportUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportViewItems);
